module.exports = __webpack_public_path__ + "img/logo.0bdfa7f8.svg";